import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TrustpilotWidgetLoaderService {
  private static readonly SCRIPT_SRC = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  private loadPromise: Promise<void> | undefined;

  constructor(@Inject(DOCUMENT) private readonly doc: Document) { }

  public load(): Promise<void> {
    if (this.loadPromise) {
      return this.loadPromise;
    }

    if (window.Trustpilot) {
      this.loadPromise = Promise.resolve();
      return this.loadPromise;
    }

    this.loadPromise = new Promise<void>((resolve, reject) => {
      const script = this.doc.createElement('script');
      script.type = 'text/javascript';
      script.src = TrustpilotWidgetLoaderService.SCRIPT_SRC;
      script.async = true;

      const cspNonce = this.doc.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');
      if (cspNonce) {
        script.nonce = cspNonce;
      }

      script.addEventListener('load', () => resolve());
      script.addEventListener('error', () => {
        this.loadPromise = undefined;
        reject(new Error('Trustpilot script failed to load'));
      });

      this.doc.head.appendChild(script);
    });

    return this.loadPromise;
  }
}

declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement(element: HTMLElement, forceReload?: boolean): void;
    };
  }
}
